//--------------- IMPORTAÇÕES ---------------//
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { checkService } from "./services";
import { Main } from "./components";



//--------------- EXPORTAÇÃO DA PÁGINA LOGIN ---------------//
export default function Login() {


  //--------------- CRIAÇÃO DE HOOKS ---------------//
  const navigate = useNavigate(); // Navegador para a navegação entre páginas


  //--------------- USE EFFECT DE INICIALIZAÇÃO ---------------//
  useEffect(() => {
    handleChecking();
  }, []);



  //--------------- FUNÇÃO ASSÍNCRONA HANDLE CHECKING ---------------//
  async function handleChecking() {
    const response = await checkService();
    if (response) {
      navigate("/");
    }
  };



  //--------------- RETORNO DA PÁGINA LOGIN ---------------//
  return (
    <>

      {/* DIV PRINCIPAL */}
      <Main />

    </>
  );


}